import { formatServerTime, serverOffsetLabel, useServerOffset, useServerTime } from './serverTime';

export function ServerClock() {
  const time = useServerTime();
  const offset = useServerOffset();
  return (
    <div
      className="flex items-baseline gap-2 text-muted"
      title={`Platform server time${offset === null ? '' : ` (${serverOffsetLabel(offset)})`}. All times in the terminal use it.`}
    >
      <span className="text-xs uppercase tracking-wide">Server</span>
      <time className="num text-fg" dateTime={time?.toISOString()}>
        {time ? formatServerTime(time) : '--:--:--'}
      </time>
    </div>
  );
}
